import { Injectable } from '@angular/core';
import { CommonService } from '../../service/common.service'
import * as color from '../../config/colors'
import * as background from '../../config/backgroundColor'
import * as backgroundColor from '../../config/backgroundColor';
import * as toolbox from '../../config/toolbox';
import * as tooltip from '../../config/tootip';
import * as legend from '../../config/legend';
import * as xAxis from '../../config/xAxis';
import * as series from '../../config/series';
import * as yAxis from '../../config/yAxis';
import { EventWaveComponent } from './event-wave.component';
import { EChartOption } from 'echarts';
import { cloneDeep, isNil } from 'lodash';
import * as grid from '../../config/grid';
import { ECharts } from 'echarts';


@Injectable({
  providedIn: 'root'
})
export class EventWareService {
  style = this.commonService.changeFontSize();

  constructor(
    private commonService: CommonService
  ) { }

  getChartxAxis() {
    return xAxis.getXaxisOfNoiseEventWave([], 0, '')
  }
  getChartyAxis() {
    return yAxis.getYaxisOfNoiseDropLine("")
  }
  getChartToolbox() {
    return toolbox.getNoiseEventWaveToolboxV2()
  }

  getChartLegend() {
    let len = legend.getLegendBottomScroll(this.style)
    len["icon"] = "circle"
    return len;
  }


  getDefaultTooltip() {
    return tooltip.getNoiseDropLineTooltip()
  }

  changeChartTitleDark(component: EventWaveComponent, darkMode: boolean) {
    if (darkMode) {
      component.chartTitleColor = color.darkModeTextColor;
      component.cardBgColor = background.darkModeBGColor;
    }
  }

  chartBackgroundColorDarkMode(chartOption) {
    chartOption.backgroundColor = background.darkModeBGColor;
  }


  xAxisDarkMode(xAxisOption) {
    xAxisOption.forEach(e => {
      if (isNil(e['axisLabel'])) {
        e['axisLabel'] = {};
      }
      e['axisLabel']['color'] = color.darkModeTextColor;
      if (isNil(e['nameTextStyle'])) {
        e['nameTextStyle'] = {};
      }
      e['nameTextStyle']['color'] = color.darkModeTextColor;
    });
  }


  yAxisDarkMode(yAxisOption) {
    yAxisOption.forEach(e => {
      if (isNil(e['axisLabel'])) {
        e['axisLabel'] = {};
      }
      e['axisLabel']['color'] = color.darkModeTextColor;
      if (isNil(e['nameTextStyle'])) {
        e['nameTextStyle'] = {};
      }
      e['nameTextStyle']['color'] = color.darkModeTextColor;
      if (isNil(e['splitLine'])) {
        e['splitLine'] = {
          lineStyle: {
            color: color.darkModeTextColor
          }
        };
      } else {
        if (isNil(e['splitLine']['lineStyle'])) {
          e['splitLine']['lineStyle'] = {
            color: color.darkModeTextColor
          }
        } else {
          e['splitLine']['lineStyle']['color'] = color.darkModeTextColor;
        }
      }
    });
  }


  colorsDarkMode(colors: string[]) {
    colors.length = 0;
    color.darkModeColors.forEach(e => {
      colors.push(e);
    });
  }


  legendDarkMode(legendOption) {
    if (isNil(legendOption['textStyle'])) {
      legendOption['textStyle'] = {
        color: color.darkModeTextColor
      };
    } else {
      legendOption['textStyle']['color'] = color.darkModeTextColor;
    }
  }

  seriesDarkMode(seriesOption: EChartOption.Series) {
    if (isNil(seriesOption['label'])) {
      seriesOption['label'] = {};
    }
    seriesOption['label']['color'] = color.darkModeTextColor;
  }


  setSmallModeGrid(gridOption: EChartOption.Grid) {
    gridOption.top = grid.baseSmallPadding;
    gridOption.bottom = grid.baseSmallPadding;
    gridOption.left = grid.baseSmallPadding;
    gridOption.right = grid.baseSmallPadding;
  }

  setLegendPosition(gridOption: EChartOption.Grid, legendOption, legendPosition: string) {
    switch (legendPosition) {
      case "top":
        legendOption.show = false;
        break;
      case "right":
        gridOption.right = legend.rightLegendWidth;
        // delete legendOption.width;
        legendOption['top'] = legendOption['itemGap'];
        // legendOption['top'] = 0;
        legendOption['right'] = gridOption.left;
        legendOption['bottom'] = gridOption.bottom;
        legendOption['width'] = gridOption.right;
        legendOption['orient'] = "vertical";
        legendOption['pageIcons'] = {
          vertical: [
            "path://M472.064 272.448l-399.232 399.232c-22.08 22.08-22.08 57.792 0 79.872 22.016 22.016 57.792 22.08 79.872 0L512 392.256l359.296 359.296c22.016 22.016 57.792 22.08 79.872 0 22.08-22.08 22.016-57.792 0-79.872L551.936 272.448C529.856 250.432 494.144 250.432 472.064 272.448z",
            "path://M472.064 751.552 72.832 352.32c-22.08-22.08-22.08-57.792 0-79.872 22.016-22.016 57.792-22.08 79.872 0L512 631.744l359.296-359.296c22.016-22.016 57.792-22.08 79.872 0 22.08 22.08 22.016 57.792 0 79.872l-399.232 399.232C529.856 773.568 494.144 773.568 472.064 751.552z"
          ],
        };
        legendOption['textStyle']['padding'] = [2, 0, 0, 0];
        break;
      default:
        gridOption.bottom = legend.bottomLegendHeight;
        break;
    }
  }


  setXaxisName(xAxisOption, name: string) {
    xAxisOption.forEach(e => {
      e.name = name;
    })
  }


  setYnameGap(yAxisOption, yNameGap: number) {
    yAxisOption.forEach(e => {
      e.nameGap = yNameGap;
    });
  }

  chartColorsChange(colors: string[], colorList: string[]) {
    colors.length = 0;
    colorList.forEach(e => {
      colors.push(e);
    });
  }

  topLegendChange(legendDatas: any[], optionInit: ECharts) {
    legendDatas.forEach(e => {
      if (e.checked) {
        optionInit.dispatchAction({
          type: "legendSelect",
          name: e.value
        });
      } else {
        optionInit.dispatchAction({
          type: "legendUnSelect",
          name: e.value
        });
      }
    });
  }

  //todo tooltip显示格式化
  setTooltipFormat(value: string) {
    return tooltip.getNoiseDropLineTooltip(value);
  }



  zoomTrigger(e: any, optionInit: ECharts, zoomHistory) {
    if (e.type == 'zoom_enlarge' && e.active) {
      optionInit.dispatchAction({
        type: "takeGlobalCursor",
        key: 'dataZoomSelect',
        dataZoomSelectActive: true
      });
    } else if (e.type == 'zoom_enlarge' && !e.active) {
      optionInit.dispatchAction({
        type: "takeGlobalCursor",
        key: 'dataZoomSelect',
        dataZoomSelectActive: false
      });
    }else {
      if (zoomHistory.length >= 2) {
        let len = zoomHistory.length -2
        optionInit.dispatchAction({
          type: "dataZoom",
          startValue: zoomHistory[len].batch[0].startValue,
          endValue: zoomHistory[len].batch[0].endValue
        });
        zoomHistory.pop()
      } else if (zoomHistory.length == 1) {
        optionInit.dispatchAction({
          type: "dataZoom",
          start: 0,
          end: 100
        });
       zoomHistory.pop()
      } else {
        return
      }
    }
  }




}
